import type {
  CreateClusterFormData,
  UpdateClusterRequest,
} from '../domain/types'
import { mapFormDataToCreateRequest } from '../domain/types'
import { clustersApi } from './api'

export const clusterRepository = {
  async list() {
    return clustersApi.getClusters()
  },

  async get(clusterId: string) {
    return clustersApi.getCluster(clusterId)
  },

  async getServersForCluster() {
    return clustersApi.getServersForCluster()
  },

  async create(formData: CreateClusterFormData) {
    const apiRequest = mapFormDataToCreateRequest(formData)
    return clustersApi.createCluster(apiRequest)
  },

  async update(clusterId: string, body: UpdateClusterRequest) {
    return clustersApi.updateCluster(clusterId, body)
  },
}
